'use client'

import { usePathname } from 'next/navigation'
import Navbar from "@/components/home/navbar"
import Footer from "@/components/home/footer"

interface ConditionalLayoutProps {
  children: React.ReactNode
}

export default function ConditionalLayout({ children }: ConditionalLayoutProps) {
  const pathname = usePathname()
  
  // Pages où on ne veut PAS afficher la navbar et footer
  const appPages = [
    '/chat',
    '/login', 
    '/dashboard',
    '/error',
    '/test-supabase'
  ]
  
  // Vérifier si on est sur une page d'application
  const isAppPage = appPages.some(page => pathname.startsWith(page)) || pathname.startsWith('/auth')
  
  if (isAppPage) {
    // Page d'application : pas de navbar/footer
    return <>{children}</>
  }
  
  // Page publique : avec navbar et footer
  return (
    <div className="flex flex-col">
      <Navbar />
      {children}
      <div className="w-full">
        <Footer />
      </div>
    </div>
  )
} 